import { EmailThreadCounts } from '@rossum/api-client/emailThreads';
import { IconCustomMailGroup, IconFiles } from '@rossum/ui/icons/tabler';
import {
  Badge,
  Chip,
  Stack,
  SvgIcon,
  ToggleButton,
  ToggleButtonGroup,
} from '@rossum/ui/material';
import { ViewOptions } from '../../document-list-base/types';

const MAX_ERRORS = 99;

type Props = {
  view: ViewOptions;
  isVisible: boolean;
  setView: (view: ViewOptions) => void;
  counts: EmailThreadCounts | undefined;
};

const ViewSwitch = ({ view, isVisible, setView, counts }: Props) => {
  const newEmailsExist = !!counts?.withNewReplies;
  const newEmailsWithUnprocessableAttachment =
    counts?.recentWithNoDocumentsNotReplied ?? 0;

  if (!isVisible) {
    return null;
  }

  return (
    <ToggleButtonGroup color="secondary" value={view}>
      <ToggleButton
        value="documents"
        onClick={() => setView('documents')}
        aria-selected={view === 'documents' ? 'true' : undefined}
        data-cy="switch-documents"
        sx={{ px: 0.5 }}
      >
        <SvgIcon>
          <IconFiles />
        </SvgIcon>
      </ToggleButton>
      <ToggleButton
        value="emails"
        onClick={() => setView('emails')}
        aria-selected={view === 'emails' ? 'true' : undefined}
        data-cy="switch-emails"
        sx={{ px: 0.5 }}
      >
        <Badge
          color="primary"
          variant="dot"
          invisible={!newEmailsExist}
          slotProps={{
            badge: {
              sx: {
                top: 2,
                right: -5,
              },
            },
          }}
        >
          <Stack gap={0.5} direction="row" alignItems="center">
            <SvgIcon>
              <IconCustomMailGroup />
            </SvgIcon>
            {newEmailsWithUnprocessableAttachment ? (
              <Chip
                color="warning"
                data-cy="annotation-list-tab-label"
                label={
                  newEmailsWithUnprocessableAttachment > MAX_ERRORS
                    ? '99+'
                    : newEmailsWithUnprocessableAttachment
                }
              />
            ) : null}
          </Stack>
        </Badge>
      </ToggleButton>
    </ToggleButtonGroup>
  );
};

export { ViewSwitch };
